export const getPopularFlights = (state) => state.popularFlights;
